import { formatWithPrefix } from 'vlcishared';

const UNIDAD_MEDIDA = 'Wh';
export const ID_ENERGIA_CONSUMIDA = 'IS_ENE_001';
export const ID_ENERGIA_VERTIDA = 'IS_ENE_002';
const ESCALA_VERTIDA_RESPECTO_CONSUMIDA = 0.01;

export function formatValue(dato) {
  const { value, prefix } = formatWithPrefix(dato);
  const formattedValue = value.toLocaleString('es-ES');
  return `${formattedValue} ${prefix}${UNIDAD_MEDIDA}`;
};

export function tooltipFormatterAxis(params) {
  const categoria = params[0].axisValue;
  const categoriaFormateada =
    categoria.includes('/') && categoria.split('/').length === 3
      ? formatToDayMonthSlash(categoria)
      : categoria.length === 6
      ? formatToMonthYearSlash(categoria)
      : categoria;

  return (
    `${categoriaFormateada}<br/>` +
    params
      .map(
        (item) =>
          `<span style="float: left;font-weight: 500;color: #666;">${
            item.marker
          } ${
            item.seriesName
          }:</span><span style="float: right; padding-left: 30px;font-weight: 600;color: #333;"> ${formatValue(
            item.value,
          )}</span>`,
      )
      .join('<br/>')
  );
}

export function deepCloneWithFunctions(obj) {
  if (obj === null || typeof obj !== 'object') return obj;

  if (Array.isArray(obj)) {
    return obj.map(deepCloneWithFunctions);
  }

  const cloned = {};
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const value = obj[key];
      cloned[key] =
        typeof value === 'function' ? value : deepCloneWithFunctions(value);
    }
  }

  return cloned;
}

export function formatToDayMonthSlash(dateStr) {
  const [yyyy, mm, dd] = dateStr.split('/');
  return `${dd}/${mm}`;
}
export function formatToMonthYearSlash(dateStr) {
  return `${dateStr.substring(0, 4)}/${dateStr.substring(4, 6)}`;
}

export function ajustarEscalaEje(serieConsumidaData) {
  const maxValue = Math.max(...serieConsumidaData);
  console.log(maxValue)
  return maxValue * ESCALA_VERTIDA_RESPECTO_CONSUMIDA;
}
